import { Roles } from "../utils/lists";

export interface Deposit {
    bank_id : number
    createdAt : string
    from : string
    hash : string
    id : number
    organization_id : number
    status : string
    symbol : string
    target_user_id : number
    trx_id : string
    type : string
    updatedAt : string
    value : string
    wallet_id : string
}

export enum DepositType {
    'USER' = "user",
    'OWNER' = 'owner',
    'ALL' = 'all',
    'SUPPLIER' = 'supplier',
    'DEPOSITOR' = 'depositor'
}

// Traduz o role do usuario (ex: "Owner") para o DepositType da listagem ("owner").
// Comparacao case-insensitive: Roles usa capitalizacao ("Super Admin") e
// DepositType usa minusculas, entao a igualdade estrita nunca casava.
export const depositTypeForRole = (role?: string | null): DepositType => {
    const r = (role ?? "").toLowerCase();
    if (r === Roles.owner.toLowerCase())      return DepositType.OWNER;
    if (r === Roles.superAdmin.toLowerCase()) return DepositType.ALL;
    return DepositType.USER;
};
